import { ThemeEvents } from '@theme/events';

class ProductShippingInfo extends HTMLElement {
  #closestSection = null;

  get #productId() {
    return this.getAttribute('data-product-id');
  }

  get #threshold() {
    return Number(this.getAttribute('threshold') ?? 3000);
  }

  get #eligibleMessage() {
    return this.querySelector('[data-ref="eligibleMessage"]');
  }

  get #ineligibleMessage() {
    return this.querySelector('[data-ref="ineligibleMessage"]');
  }

  connectedCallback() {
    this.#closestSection = this.closest('.shopify-section');
    this.#closestSection?.addEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate);
  }

  disconnectedCallback() {
    this.#closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate);
    this.#closestSection = null;
  }

  /**
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  #onVariantUpdate = (event) => {
    const target = event.target;

    if (target instanceof HTMLElement && target.getAttribute('data-product-id') !== this.#productId) {
      return;
    }

    const { variant } = event.detail;

    this.#updateShippingMessage(variant);
  };

  #updateShippingMessage(variant) {
    const eligibleMessage = this.#eligibleMessage;
    const ineligibleMessage = this.#ineligibleMessage;

    if (!eligibleMessage || !ineligibleMessage) return;

    const price = variant?.price ?? 0;
    const isEligible = price > this.#threshold;

    if (isEligible) {
      eligibleMessage.removeAttribute('hidden');
      ineligibleMessage.setAttribute('hidden', '');
    } else {
      ineligibleMessage.removeAttribute('hidden');
      eligibleMessage.setAttribute('hidden', '');
    }
  }
}

if (!customElements.get('product-shipping-info')) {
  customElements.define('product-shipping-info', ProductShippingInfo);
}
